import { Link } from "react-router-dom";
import { homepageData } from "@/mocks/homepage";

export default function TestimonialSection() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3">用户心声</h2>
          <p className="text-foreground-600 text-sm">听听我们的用户怎么说</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {homepageData.testimonials.map((t) => (
            <div
              key={t.name}
              className="bg-background-100 border border-background-200/70 rounded-xl p-6"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-12 h-12 rounded-full overflow-hidden flex-shrink-0">
                  <img src={t.avatar} alt={t.name} className="w-full h-full object-cover" />
                </div>
                <div>
                  <div className="text-sm font-semibold text-foreground-900">{t.name}</div>
                  <div className="text-xs text-foreground-500">{t.role}</div>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">{t.content}</p>
              <div className="flex items-center gap-1 mt-4">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-amber-400 text-sm w-4 h-4 flex items-center justify-center"></i>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}